import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { isSingleSig, nextVerification } from './authorization';
import { cloneDeep } from './utils';
import { AuthType, PubKeyEncoding, StacksMessageType } from './constants';
import { SigningError } from './errors';
export var TransactionSigner =
/*#__PURE__*/
function () {
  function TransactionSigner(transaction) {
    var _this = this;

    _classCallCheck(this, TransactionSigner);

    this.transaction = transaction;
    this.sigHash = transaction.signBegin();
    this.originDone = false;
    this.checkOversign = true;
    this.checkOverlap = true;
    var spendingCondition = transaction.auth.spendingCondition;

    if (spendingCondition && !isSingleSig(spendingCondition)) {
      if (spendingCondition.fields.filter(function (field) {
        return field.contents.type === StacksMessageType.MessageSignature;
      }).length >= spendingCondition.signaturesRequired) {
        throw new Error('SpendingCondition has more signatures than are expected');
      }

      spendingCondition.fields.forEach(function (field) {
        if (field.contents.type === StacksMessageType.MessageSignature) {
          var signature = field.contents;
          var nextVerify = nextVerification(_this.sigHash, transaction.auth.authType, spendingCondition.fee, spendingCondition.nonce, PubKeyEncoding.Compressed, signature);
          _this.sigHash = nextVerify.nextSigHash;
        }
      });
    }
  }

  _createClass(TransactionSigner, [{
    key: "signOrigin",
    value: function signOrigin(privateKey) {
      if (this.checkOverlap && this.originDone) {
        throw new SigningError('Cannot sign origin after sponsor key');
      }

      if (this.transaction.auth === undefined) {
        throw new SigningError('"transaction.auth" is undefined');
      }

      if (this.transaction.auth.spendingCondition === undefined) {
        throw new SigningError('"transaction.auth.spendingCondition" is undefined');
      }

      if (!isSingleSig(this.transaction.auth.spendingCondition)) {
        var spendingCondition = this.transaction.auth.spendingCondition;

        if (this.checkOversign && spendingCondition.fields.filter(function (field) {
          return field.contents.type === StacksMessageType.MessageSignature;
        }).length >= spendingCondition.signaturesRequired) {
          throw new Error('Origin would have too many signatures');
        }
      }

      var nextSighash = this.transaction.signNextOrigin(this.sigHash, privateKey);
      this.sigHash = nextSighash;
    }
  }, {
    key: "appendOrigin",
    value: function appendOrigin(publicKey) {
      if (this.checkOverlap && this.originDone) {
        throw Error('Cannot append public key to origin after sponsor key');
      }

      if (this.transaction.auth === undefined) {
        throw new Error('"transaction.auth" is undefined');
      }

      if (this.transaction.auth.spendingCondition === undefined) {
        throw new Error('"transaction.auth.spendingCondition" is undefined');
      }

      this.transaction.appendPubkey(publicKey);
    }
  }, {
    key: "signSponsor",
    value: function signSponsor(privateKey) {
      if (this.transaction.auth === undefined) {
        throw new SigningError('"transaction.auth" is undefined');
      }

      if (this.transaction.auth.authType !== AuthType.Sponsored) {
        throw new SigningError('"transaction.auth.authType" is not AuthType.Sponsored');
      }

      var nextSighash = this.transaction.signNextSponsor(this.sigHash, privateKey);
      this.sigHash = nextSighash;
      this.originDone = true;
    }
  }, {
    key: "getTxInComplete",
    value: function getTxInComplete() {
      return cloneDeep(this.transaction);
    }
  }, {
    key: "resume",
    value: function resume(transaction) {
      this.transaction = cloneDeep(transaction);
      this.sigHash = transaction.signBegin();
    }
  }], [{
    key: "createSponsorSigner",
    value: function createSponsorSigner(transaction, spendingCondition) {
      if (transaction.auth.authType != AuthType.Sponsored) {
        throw new SigningError('Cannot add sponsor to non-sponsored transaction');
      }

      var tx = cloneDeep(transaction);
      tx.setSponsor(spendingCondition);
      var originSigHash = tx.verifyOrigin();
      var signer = new this(tx);
      signer.originDone = true;
      signer.sigHash = originSigHash;
      signer.checkOversign = true;
      signer.checkOverlap = true;
      return signer;
    }
  }]);

  return TransactionSigner;
}();